export default __webpack_public_path__ + "static/media/sarawak.5f102ada.png";